import React from "react";
import { useRouteMatch } from "react-router";
function CopyrightFooter() {
  const { url } = useRouteMatch();
  return (
    <footer
      className={`col-12 align-self-end text-center fs-13 footer ${
        url === "/" ? "text-white" : "text-mute"
      }`}
    >
      <p>
        Copyright © 2019{" "}
        <a href="https://narayaniconcept.com">Narayani Group</a>. All rights
        reserved.
      </p>
    </footer>
  );
}
export default React.memo(CopyrightFooter);
